const $ = window.jQuery;

export default class Loader {

  constructor() {}

  show() {
    $('html').addClass('is-loading');
    
    $('#page-loader_progress')
      .removeClass('is-animated')
      .width(0);
    
    clearTimeout( this.pageLoaderTimeout );
    setTimeout(() => {
      $('#page-loader').addClass('is-visible');
      $('#page-loader_progress')
        .addClass('is-animated')
        .width( (20 + Math.random() * 50) + '%' );
    }, 50);
  }

  hide() {
    $('html').removeClass('is-loading');
    $('#page-loader_progress').width( '101%' );
    this.pageLoaderTimeout = setTimeout(function() {
       $('#page-loader_progress').removeClass("is-animated");
      $('#page-loader').removeClass('is-visible');
    }, 500);
  }
}